



import Vue from 'vue'
import { MessageAlert } from '@/Domain/MessageAlert'
import { EventBus } from '@/Infrastructure/EventBus/EventBus'

interface iMessageAlert {
  messageAlert: MessageAlert | undefined
}

export default Vue.extend({
  name: 'MessageAlert',
  data (): iMessageAlert {
    return {
      messageAlert: undefined
    }
  },
  mounted () {
    EventBus.$on('messageAlert', ($event: MessageAlert) => {
      this.messageAlert = $event
      this.showMessage()
    })
  },
  methods: {
    showMessage (): void {
      if (this.messageAlert !== undefined) {
        this.$swal({
          position: 'top-end',
          icon: this.messageAlert.type(),
          title: this.messageAlert.message(),
          showConfirmButton: false,
          timer: this.messageAlert.time()
        })
      }
    }
  }
})
